'use client';

import { useFetchFromApi } from '@/clientApi';
import { useEffect } from 'react';
import { useTranslations } from 'next-intl';
import { Link } from '@/i18n/routing';
import ErrorPageLayout from './ErrorPageLayout';

export function ServerErrorContainer({
    error
}: {
  error: Error & { digest?: string }
  reset: () => void
}) {
    const fetchFromApi = useFetchFromApi();
    const t = useTranslations('errors');
    const refreshPage = () => {
        window.location.reload();
    };

    useEffect(() => {
        fetchFromApi('/errors', {
            method: 'POST',
            body: JSON.stringify({
                message: JSON.stringify({
                    name: error.name,
                    message: error.message,
                    stack: error.stack?.split('\n'),
                    cause: error.cause,
                    digest: error.digest
                })
            }),
            headers: {
                'Content-Type': 'application/json'
            }
        });
    }, [error, fetchFromApi]);

    return (
        <ErrorPageLayout
          title={t('unexpected.title')}
          subtitle={t('unexpected.subtitle')}
          description={t('unexpected.description')}
          imageSrc='/img/errors/something-went-wrong.png'
          imageWidth={266}
          imageHeight={240}
          actions={
                <Link href='/'>
                    <ErrorPageLayout.Button
                      variant='stroke'
                      size='lg'
                      innerText={t('common.refresh')}
                      onClick={refreshPage}
                    />
                </Link>
            }
        />
    );
}
